import { render, staticRenderFns } from "./button-expand.vue?vue&type=template&id=205b27e0"
import script from "./button-expand.vue?vue&type=script&lang=js"
export * from "./button-expand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports